<template>
  <v-dialog
    v-model="display"
    fullscreen
    eager
  >
    <v-card
      color="card"
      height="100%"
    >
      <close-button
        @clickBtn="closeCardPick"
      />
      <div class="text-h3 text-center py-3">
        {{ $t('pick_card_dialog.player_pick') }}
      </div>
      <filter-menu
        @toggleLastScores="toggleLastScores($event)"
      />
      <cards-list
        :show-average-score="showAverageScore"
        :user-slug="userSlug"
        :game-week-number="gameWeekNumber"
        :show-last-scores="showLastScores"
        :selected-cards="selectedCards"
        :forbidden-cards="forbiddenCards"
        @cardPicked="cardPicked($event)"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CardsList from '@/components/Card/CardsList.vue';
import FilterMenu from '@/components/Card/Filter/FilterMenu.vue';
import CloseButton from '@/components/CloseButton.vue';
import { useUserStore } from '@/store/user.module';

export default {
  name: 'PickCardDialog',
  components: {
    CardsList,
    FilterMenu,
    CloseButton,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    gameWeekNumber: {
      type: Number,
      default: null,
    },
    showAverageScore: {
      type: Boolean,
      default: false,
    },
    selectedCards: {
      type: Array,
      default() {
        return [];
      },
    },
    forbiddenCards: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showLastScores: false,
    };
  },
  computed: {
    display: {
      get() { return this.modelValue; },
      set(display) {
        this.$emit('update:model-value', display);
      },
    },
    userSlug() {
      const userStore = useUserStore();
      return userStore.currentUser?.slug;
    },
  },
  methods: {
    closeCardPick() {
      this.display = false;
    },
    cardPicked(card) {
      this.$emit('cardPicked', card);
    },
    toggleLastScores(showLastScores) {
      this.showLastScores = showLastScores;
    },
  },
};
</script>

<style scoped>
.card-list {
  max-height: calc(100% - 184px);
}
</style>
